import { getSideBarOptions } from "../services/service";
import {makeAutoObservable} from 'mobx';
import Cookies from "js-cookie";


class SideMenuStore {
    options = [];

    constructor(){
        makeAutoObservable(this)
    }

    getOptions = async () => {
        const enrollPlan = "";
        let optionsData = await getSideBarOptions(enrollPlan);
        // console.log(optionsData)
        optionsData = optionsData.filter((item: any) => item.slug !== "/my-portfolio");
        return optionsData || [];
    };




}

export const sideMenuStore = new SideMenuStore();